<template>
  <div class="page" ref="viewBox">
    <Loading v-if="isLoading" />
    <div v-else-if="newsinfo.length==0" class="news-content">
      <Tips />
    </div>
    <div v-else class="news-content" >
      <div class="news-top">
        <div class="tit">{{newsinfo.title}}</div>
        <div class="sub-tit" v-if="newsinfo.subtitle">{{newsinfo.subtitle}}</div>
        <div class="meta">
          <div class="author" v-if="newsinfo.author">作者：{{newsinfo.author}}</div>
          <div class="date">{{newsinfo.updatetime | date}}</div>
        </div>
      </div>
      <div class="news-body" v-html="newsinfo.content"></div>
      <div class="comment-box">
        <div class="post" v-if="newsinfo.comment.length==0">
          <router-link  class="post" to="/commentpost">写留言
          </router-link>
        </div>
        <div class="news-comment" v-if="newsinfo.comment.length>0">
          <router-link class="right-post" to="/commentpost">写留言
          </router-link><div class="top-comment">精品留言</div>
          <Comment
            v-for="(comment, index) in newsinfo.comment"
            :id="comment.id"
            :comment="comment"
            :key="index"
          >
          </Comment>
          <!--  -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { FETCH_NEWSINFO, UPDATESET_CONFIG } from "@/store/actions.type";
import Loading from "@/components/Loading";
import Tips from "@/components/Tips";
import Comment from "@/components/Comment";

export default {
  name: "news",
  components: {
    Loading,
    Tips,
    Comment,
  },
  data () {
    return {
      id:'',
      box:'',
    }
  },
  metaInfo(){
    return {
      title: this.newsinfo.title,
    }
  },
  watch: {
    $route(to, from, next) {
      if(to.params.id){
        Promise.all([
        store.dispatch(FETCH_NEWSINFO, {id:to.params.id}),
        //store.dispatch(FETCH_COMMENTS, to.params.id)
        ]).then(() => {
          next();
        });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch(FETCH_NEWSINFO, {id:to.params.id}),
      //store.dispatch(FETCH_COMMENTS, to.params.id)
    ]).then(() => {
      next();
    });
  },
  created() {
      store.dispatch(UPDATESET_CONFIG, {isShowBack:false,isShowFooter:false});
  },
  mounted() {
    // 监听这个dom的scroll事件
    window.addEventListener('scroll', this.handleFun, false)
  },
  methods:{
    handleFun(){
      if(window.scrollY > 50){
        store.dispatch(UPDATESET_CONFIG, {isShowBack:true});
      }else{
        store.dispatch(UPDATESET_CONFIG, {isShowBack:false});
      }
    }
  },
  computed: {
    ...mapGetters(["isLoading", "newsinfo"]),
  },
  beforeDestroy(){
    window.removeEventListener("scroll",this.handleFun)
  }
};
</script>
<style scoped>

.page{
  margin-bottom:0;
}
</style>